import { useCreateApplicationApplicantDetailsQuery } from "@lending/hooks/queries/ApplicationApplicantDetails/useCreateApplicationApplicantDetailsQuery";
import { useLendingApplicationID } from "@lending/hooks/useLendingApplicationID";
import { APPLICATION_RELATIONSHIP } from "@lending/types";
import type { PersonalInfoApiData } from "@lending/hooks/queries/PersonalInfo/types";

function useCreateCoApplicantDetailsQuery() {
  const lendingApplicationID = useLendingApplicationID();
  const createApplicationApplicantDetails = useCreateApplicationApplicantDetailsQuery();

  const createCoApplicantDetails = async (
    data: PersonalInfoApiData & { is_spouse?: boolean | null }
  ) => {
    if (!lendingApplicationID) {
      throw new Error("Missing application id for co-applicant creation.");
    }

    return createApplicationApplicantDetails.mutateAsync({
      body: {
        application: lendingApplicationID,
        first_name: data.first_name,
        last_name: data.last_name,
        email: data.email,
        phone: data.phone,
        tax_id: data.tax_id,
        date_of_birth: data.date_of_birth,
        // Only include is_spouse when the form provided it. Sending an explicit null when the
        // checkbox is disabled would clear any previously-saved value on the server.
        ...("is_spouse" in data ? { is_spouse: data.is_spouse } : {}),
        // for now, just hard-code the co_applicant relationship. We can update when we have more types
        application_relationship: APPLICATION_RELATIONSHIP.CO_APPLICANT,
      },
    });
  };

  return {
    createCoApplicantDetails,
    isPending: createApplicationApplicantDetails.isPending,
  };
}

export { useCreateCoApplicantDetailsQuery };
